<template>

    <nav class="breadcrumb">
        <ul>
            <li v-for="(item, index) in breadcrumbData" :key="index">
                <span v-if="item.icon && item.icon !== ''">
                    <!-- <img :src="`${process.env.BASE_URL}${item.icon}`"/> -->
                    <div class="icon" :style="{ backgroundImage: 'url(' + item.icon + ')' }" />
                </span>
                <!-- 如果不是最后一个元素，显示链接并绑定点击事件 -->
                <span v-if="index !== breadcrumbData.length - 1">
                    <a href="javascript:void(0)" @click="navigateTo(item)">{{ item.key }}</a>
                </span>
                <!-- 最后一个元素不带链接 -->
                <span class="end" v-else>{{ item.key }}</span>
                <!-- 如果不是最后一个元素，显示分隔符 -->
                <img class="gt" v-if="index !== breadcrumbData.length - 1" src="@/assets/return.svg"/>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'Breadcrumb',
    props: {
        breadcrumbData: {
            type: Array,
            required: true
        }
    },
    methods: {
        navigateTo(item) {
            // 使用 Vue Router 进行导航跳转
            this.$router.push({
                path: item.path,
                name: item.name, // 使用路由名称进行导航
                params: item.params || {}, // 可选的 params 参数
            });
        }
    }
};
</script>

<style scoped>
.breadcrumb {
    display: flex;
    align-items: center;
}

.breadcrumb ul {
    list-style-type: none;
    display: flex;
    align-items: center;
    padding: 0;
}

.breadcrumb li {
    display: flex;
    align-items: center;
    margin-right: 5px;
}

.breadcrumb a {
    text-decoration: none;
    margin-left: 8px;
    font-weight: 500;
    font-size: 22px;
    color: #00589F;
    line-height: 33px;
    text-align: left;
    font-style: normal;
    text-transform: none;

}

.end {
    font-weight: 500;
    font-size: 22px;
    color: #00589F;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    background-size: cover;
    background-position: center;
}

.gt {
    margin-left: 16px;
    margin-right: 16px;
    transform: rotate(180deg); /* 旋转180度 */
}
</style>